module.exports = __webpack_public_path__ + "img/allegion.fbec86b6.png";